import React, { Component } from "react";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import PayrollStepsManager from "../payroll/PayrollStepsManager"
import { DKLabel, showLoader, removeLoader, showAlert, showToast, TOAST_TYPE, DKButton } from 'deskera-ui-library';
import Stepper from "../common/Stepper";
import { connect } from "react-redux";
import Table from "../../services/table";
import ProcessPayrollHeader from "./ProcessPayrollHeader";
import Utility from "../../utility/Utility";
import TenantManager from "../../managers/TenantManager";
import PermissionUtils, { ACTION, MODULE } from "../user-permissions/PermissionUtils";

class ProcessPayroll extends Component {
    constructor(props) {
        super(props)
        this.tableName = PayrollStepsManager.getQueryParam(this.props.location, "module");
        this.source = PayrollStepsManager.getQueryParam(this.props.location, "origin");
        this.payrollId = PayrollStepsManager.getQueryParam(this.props.location, "id");
        this.isContractor = PayrollStepsManager.getQueryParam(this.props.location, "isContractor")
        this.isContractor = (this.isContractor == "true") ? true:false
        this.module = this.isContractor ? MODULE.CONTRACTOR_PAYRUN : MODULE.PAYRUN
        this.steps = PayrollStepsManager.getAllCreationSteps(this.onSkipToStep, this.isContractor);
        this.employeePayrollsData =this.props.payrollData.data;
        this.stepperWidth = 200;
        this.passedStep = PayrollStepsManager.getQueryParam(this.props.location, "step");
        this.tenantData = TenantManager.getPeopleTenantData();
        this.state = {
            currentStep: parseInt(this.passedStep),
            tenantData: this.tenantData && this.tenantData.tenant ? this.tenantData.tenant : {},
        };
    }

    componentDidMount() {
      RouteManager.setPresenter(this);
      if (Utility.isEmpty(this.payrollId) && Utility.isEmpty(this.passedStep)) {
          // RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
          this.isContractor === "true"
            ? RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST)
            : RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
      }
      /* TableName Query Param is required to proceed */
      if (!this.tableName) {
        RouteManager.navigateToPage(this.source || "/");
      }
    }

    onSkipToStep = (event, index) => {
        const { currentStep } = this.state;

        /* By default expected step is to move forward */
        const expectedStep = index ?? currentStep + 1;

        /* If it's the last step */
        if (expectedStep === this.steps.length) {
            this.handleImportConfirmation();
            return;
        }

        if (this.isInvalidStep(expectedStep)) {
          const { requiredProps } = this.steps[expectedStep];
          let errorInfo = "";
          for(let item=0; item < requiredProps.length; item++) {
            let propsValue = requiredProps[item];
            if (this.state[propsValue] && this.state[propsValue].length > 0) {
              errorInfo = this.steps[currentStep].reqError[propsValue];
              break;
            }
          }
          errorInfo = !Utility.isEmpty(errorInfo) ? errorInfo : `Some of the employees have incomplete profiles. Please update their profiles to proceed.`;
          showToast(errorInfo, TOAST_TYPE.FAILURE);
        } else {
            this.setState({ currentStep: expectedStep });
        }
        // this.setState({ currentStep: expectedStep });
    };

    isInvalidStep = (expectedStep) => {
        if (expectedStep < 0 || expectedStep >= this.steps.length) return false;

        /* Check if component has required data for expected step */
        const { requiredProps } = this.steps[expectedStep];
        if (expectedStep === 1) {
            return requiredProps.some(
              (requiredProp) =>
                this.state[requiredProp] && this.state[requiredProp].length > 0
            );
        } else {
            return requiredProps.some(
              (requiredProp) => this.state[requiredProp] === null
            );
        }
    };

    handleStepData = (data, callback) => {
    this.setState({ ...data }, callback);
  }

    getCurrentStepChild() {
        const currStep = this.steps[this.state.currentStep];
        if(!Utility.isEmpty(currStep)) {
            return currStep.getChild({
              payrollId: this.payrollId,
              state: this.state,
              tableName: this.tableName,
              setData: this.handleStepData,
              ...this.props,
              isContractor: this.isContractor,
              // handleCallback: this.handleCallback()
            });
        }
    }

    getControllers() {
        const { fileInfo, currentStep } = this.state;
        const isLastStep = currentStep === this.steps.length - 1;
        return (
          <div className="row parent-width justify-content-start m-v-l">
            <DKButton
              title={currentStep == 2 ? "Cancel Payroll" : "Cancel"}
              className="border-m ml-r bg-gray1"
              onClick={() =>
                this.isContractor ? RouteManager.navigateToPage(PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST) : RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID)
              }
            />
            {(currentStep == 0 && PermissionUtils.hasAccess(this.module, [ACTION.SUBMIT])) && (
              <DKButton
                title="Next"
                className="border-m ml-r bg-button text-white bg-app"
                onClick={this.onSkipToStep}
              />
            )}
            {(currentStep == 2 && PermissionUtils.hasAccess(this.module, [ACTION.SUBMIT])) && (
              <DKButton
                title={this.state.tenantData && this.state.tenantData.isCashfreeEnabled ? "Finish & Make Payment" : "Finish"}
                className="border-m ml-r bg-button text-white bg-app"
                onClick={(e) => this.getPaymentPopUp()}
              />
            )}
            {(currentStep == 1 && PermissionUtils.hasAccess(this.module, [ACTION.SUBMIT])) && (
              <DKButton
                title="Process Payroll"
                className="border-m ml-r bg-button text-white bg-app"
                onClick={(e) => this.getProcessPopup()}
              />
            )}
          </div>
        );
    }

    getProcessPopup() {
            const deleteConfirm = [
                {
                    title: "Not Now",
                    className: "bg-gray1 border-m",
                },
                {
                    title: "Yes",
                    className: "bg-app text-white ml-r",
                    onClick: () => this.proceedWithProcessPayroll()
                },
            ];
            showAlert(
                "Do you wish to continue to process payroll?",
                "To ensure accuracy, please review your payroll numbers and make sure they are 100% correct.",
                deleteConfirm
            )
    }

    getPaymentPopUp() {
      if (this.state.tenantData && this.state.tenantData.isCashfreeEnabled) {
        const processConfirm = [
          {
            title: "Not Now",
            className: "bg-gray1 border-m",
          },
          {
            title: "Yes",
            className: "bg-app text-white ml-r",
            onClick: () => this.submitProcessPayroll(),
          },
        ];
        showAlert(
          "This action irreversible, do you want to continue?",
          "All the payments for employees with direct deposits will be processed and paid.",
          processConfirm
        );
      } else {
        this.submitProcessPayroll();
      }
    }

    proceedWithProcessPayroll() {
        this.onSkipToStep()
    }

    submitProcessPayroll() {
        showLoader(`Payroll is being processed...`);
        Table.processPayroll(this.payrollId).finally(() => removeLoader()).then(
            (res) => {
                showToast(
                    `Payroll processed successfully`,
                    TOAST_TYPE.SUCCESS
                );
                // RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
                this.isContractor
                  ? RouteManager.navigateToPage(
                      PAGE_ROUTES.CONTRACTOR_PAYRUN_LIST
                    )
                  : RouteManager.navigateToPage(PAGE_ROUTES.PAYROLL_GRID);
            },
            (err) => {
                showToast(
                    "Some Unknown Error Occurred at Server.Please Try Again!",
                    TOAST_TYPE.FAILURE
                );
            })
    }

    render() {
        return (
          <div className="column parent-width" style={{ height: '850px' }}>
            <div className="parent-width">
              {this.isContractor  && (<div className="row"><h2 style={{ marginTop: 0 }}><b>{this.employeePayrollsData.paySchedule && this.employeePayrollsData.paySchedule ? this.employeePayrollsData.paySchedule.name : ""}</b></h2></div>)}
              <ProcessPayrollHeader isContractor={(this.isContractor ? "true":"false")} />
              <Stepper
                data={this.steps}
                currentIndex={this.state.currentStep}
                className="mb-l"
                stepperType="PAYROLL"
                width={this.stepperWidth}
              />

              <div className="m-v-l row parent-width justify-content-center">
                {this.getCurrentStepChild()}
              </div>

              {this.getControllers()}
            </div>
          </div>
        );
    }
}

const mapStateToProps = (state) => {
    return { payrollData: state.processPayroll }
}

export default connect(mapStateToProps)(ProcessPayroll);